@if(showLoader$()){
<gn-loader></gn-loader>
}
<router-outlet />